import styled from '@emotion/styled';

export const NotificationContent = styled.p`
    font-size: ${({ theme }) => theme.font.size.small};
    font-weight: ${({ theme }) => theme.font.weight.light};
`;

export const StyledLink = styled.button`
    font-size: ${({ theme }) => theme.font.size.normal};
    text-decoration: underline;
    color: ${({ theme }) => theme.color.white100};
    background: none;
    border: none;
    cursor: pointer;

    &:hover {
        text-decoration: none;
    }
`;
